import type { NavigationItem } from '@dealerportal/common';
import { useContext } from 'react';
import NavMobileDropDown from './NavMobileDropDown';
import { NavMobileMenuItemLink } from './NavMobileMenuItemLink';
import { NavigationContext } from './Navigation';

type Props = {
  menu: NavigationItem;
  depthLevel: number;
};

export default function NavMobileMenuItems(props: Props) {
  const navClassNames = useContext(NavigationContext);

  return (
    <ul
      className={`nav__grandchild-list !ui-m-0 !ui-p-0 !ui-list-none ${navClassNames.grandchildlistclass}`}
    >
      {props.menu.children
        ?.filter(({ hideInMenu, isVisible }) => !hideInMenu && isVisible)
        .map((child) => (
          <NavMobileDropDown
            key={child._id ?? child.name}
            menu={child}
            depthLevel={props.depthLevel}
            onClickHandler={() => {}}
          />
        ))}
    </ul>
  );
}
